module.exports = __webpack_public_path__ + "static/media/cp-dashboard.77085966.png";